module.exports = __webpack_public_path__ + "img/44_3.540844b1.png";